<template>
  <em
    :class="[classe]"
    :style="{'font-size': size, 'color': cor}"
    class="container-icon" >
    <slot/>
  </em>
</template>

<script>
export default {
  name: 'Icone',
  props: {
    classe: {
      type: String,
      default: 'material-icons'
    },
    size: {
      type: String,
      default: '16px'
    },
    cor: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .container-icon {
    user-select: none;
    font-family: icomoon, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: 60px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
